// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_43e734","avatar_interactive":"e76567","avatar__picture":"_0fa9f4","avatar__placeholder":"_1f1301","avatar__image":"ea1f8a"};